import { Link } from "react-router-dom";

/**
 * Reusable empty-state card.
 *
 * Props:
 *   Icon: lucide component (required)
 *   title: string
 *   body: string | node
 *   actionLabel?: string
 *   actionTo?: string         — react-router link
 *   actionOnClick?: () => void — button click handler (mutually exclusive with actionTo)
 *   testid?: string
 */
export default function EmptyState({ Icon, title, body, actionLabel, actionTo, actionOnClick, testid }) {
  const action = actionLabel && (actionTo ? (
    <Link to={actionTo} data-testid={`${testid || "empty"}-action`} className="vp-btn vp-btn-primary mt-5 inline-flex">
      {actionLabel}
    </Link>
  ) : actionOnClick ? (
    <button type="button" onClick={actionOnClick} data-testid={`${testid || "empty"}-action`} className="vp-btn vp-btn-primary mt-5">
      {actionLabel}
    </button>
  ) : null);

  return (
    <div className="vp-card p-10 sm:p-12 text-center vp-fade-in" data-testid={testid || "empty-state"}>
      {Icon && (
        <div className="mx-auto mb-5 w-14 h-14 rounded-2xl bg-[hsl(var(--accent))] text-[hsl(var(--gold-strong))] dark:text-[hsl(var(--gold))] flex items-center justify-center">
          <Icon size={26} strokeWidth={1.75} />
        </div>
      )}
      {title && <h3 className="text-lg font-semibold tracking-tight mb-2">{title}</h3>}
      {body && <p className="text-sm vp-muted max-w-md mx-auto leading-relaxed">{body}</p>}
      {action}
    </div>
  );
}
